import ApiService from "@/core/services/api.service";

// action types
export const FETCH_SCHEDULES = "fetchSchedules";
export const STORE_SCHEDULE = "storeSchedule";
export const UPDATE_SCHEDULE = "updateSchedule";
export const DESTROY_SCHEDULE = "destroySchedule";

// mutation types
export const SET_SCHEDULES = "setSchedules";
export const SET_SCHEDULES_PAGINATION = "setSchedulesPagination";

const state = {
  schedules: [],
  schedulesPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  schedules(state) {
    return state.schedules;
  },
  schedulesPagination(state) {
    return state.schedulesPagination;
  }
};

const actions = {
  [FETCH_SCHEDULES](context, programId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`programs/${programId}/schedules`, {
        params: {
          page: context.state.schedulesPagination.currentPage
        }
      })
        .then(({ data }) => {
          context.commit(SET_SCHEDULES, data.data);
          context.commit(SET_SCHEDULES_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_SCHEDULE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`programs/${payload.programId}/schedules`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_SCHEDULE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(
        `programs/${payload.programId}/schedules`,
        payload.id,
        payload
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_SCHEDULE](context, payload) {
    return new Promise(resolve => {
      ApiService.delete(`programsSchedules/${payload.id}`).then(({ data }) => {
        resolve(data);
      });
    });
  }
};

const mutations = {
  [SET_SCHEDULES](state, schedules) {
    state.schedules = schedules;
  },
  [SET_SCHEDULES_PAGINATION](state, data) {
    state.schedulesPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
